import { PhotoIcon } from "@heroicons/react/24/outline";
import styles from "./UpdatePhoto.module.scss";
import { useState, useRef, useEffect } from "react";
import { handleAddPhoto, handleDrop } from "../../../utils/UpdatePhotoUtils";
import PhotoItems from "./PhotoItems";

const UpdatePhoto = ({
  tagStyle = "",
  photos,
  setPhotos,
  productId
}) => {

  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState()

  const openFilePicker = () => {
    if (!isLoading && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const [dots, setDots] = useState('.');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev === '.') return '..';
        if (prev === '..') return '...';
        return '.';
      });
    }, 500); // Скорость анимации (0.5 секунды на шаг)

    return () => clearInterval(interval); // Очистка таймера
  }, []);

  return (
    <div className={`${styles.addPhotosContainer}`}>
      <div className={styles.addPhotosTitle}>
        {photos.length === 0 ? (
          <>
          </>
        ) : (
          <>
            <label>Фотографии</label>
            <label className={`${styles.fontGrayThin} ${styles.imagesCounter}`}>
              Загружено: {photos.length}/8
            </label>
          </>
        )}
      </div>
      <div
        className={styles.addPhotosWrapper}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(event) => { handleDrop({ event, photos, setPhotos, productId, setIsLoading }) }}
        style={{ ...tagStyle, borderRadius: '10px' }}
      >
        {photos.length === 0 && (
          <>
            <div className={styles.addFirstPhotoWrapper} onClick={openFilePicker}>
              <label>Выберите или перетащите фотографии в область</label>
              <label className={styles.fontGrayThin}>
                Форматы JPEG, JPG или PNG до 10 МБ каждый
              </label>
              <input
                ref={fileInputRef}
                type="file"
                accept='image/*'
                multiple
                onChange={(event) => { 
                    handleAddPhoto({ event, photos, setPhotos, productId, setIsLoading}) 
                }}
                style={{ display: "none" }}
              />
              <button className={styles.addPhotoButton} type="button">
                {isLoading ? <span className={styles.loadingDots}>Загрузка</span> : 'Выбрать фотографии'}
              </button>
            </div>
          </>
        )}
        <div className={styles.photosWrapper}>
          <PhotoItems
            photos={photos}
            setPhotos={setPhotos}
            productId={productId}
          />
          {photos.length > 0 && photos.length < 8 && (
            <div
              className={`${styles.addMorePhotos} group`}
              onClick={openFilePicker}
            >
              <label>
                <PhotoIcon
                  className={`${styles.addMorePhotoIcon} mx-auto h-12 w-12 text-gray-300 group-hover:text-accent`}
                  aria-hidden="true"
                />
              </label>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/jpeg,image/jpg,image/png"
                multiple
                onChange={(event) => { 
                  handleAddPhoto({ event, photos, setPhotos, productId, setIsLoading })
                }}
                style={{ display: "none" }}
              />
              <button
                className={styles.addMorePhotoButton}
                type="button"
              >
                {isLoading ? <span className={styles.loadingDots}>Загрузка</span> : 'Выбрать фото'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdatePhoto;
